const logs = {
    page_title: 'Nhật ký kiểm tra',
    title: 'Nhật ký kiểm tra',
    subtitle: 'Xem dữ liệu nhật ký của các sự kiện xác thực do người dùng của bạn thực hiện',
    event: 'Sự kiện',
    user: 'Người dùng',
    application: 'Ứng dụng',
    time: 'Thời gian',
    filter_by: 'Lọc theo',
    last_1_hour: '1 giờ qua',
    last_24_hours: '24 giờ qua',
    last_7_days: '7 ngày qua',
    last_30_days: '30 ngày qua',
    custom_range: 'Khoảng thời gian tùy chỉnh',
    from: 'Từ',
    to: 'Đến',
};
export default Object.freeze(logs);
